<template>
  <div class="about">
    <h1>Member Account Resources and Contacts</h1>
    <h2>Payment Contact</h2>
    <b-row>
      <b-col md="8" lg="6" xl="4">
        <p>
          This individual or group (email alias) will receive all payment
          notifications regarding Associate Membership upgrade/or renewal. This
          information will <strong>not</strong> be visible to users from your
          company.
        </p>
      </b-col>
    </b-row>
    <!-- forms -->
    <b-row>
      <!-- payment contact form -->
      <b-col class="mt-3" md="8" lg="6" xl="4">
        <ContactForm title="Payment Contact" memberContactType="3" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ContactForm from "@/components/ContactForm";
export default {
  name: "Payment",
  components: { ContactForm }
};
</script>
